import { Component, Inject, Vue } from 'vue-property-decorator';
import JunkItHeader from '@/components/header/junk-it-header.vue'
import TorontoPricing from '@/components/toronto-pricing/toronto-pricing.vue'
import Questions from '@/components/questions/questions.vue'
import ClientsReviews from '@/components/clients-reviews/clients-reviews.vue'
import JunkItFooter from '@/components/footer/junk-it-footer.vue'
import BinRentalPricing from '@/components/bin-rental-pricing/bin-rental-pricing.vue'

@Component({
	components: {
		JunkItHeader,
		ClientsReviews,
		Questions,
		JunkItFooter,
		TorontoPricing,
		BinRentalPricing
	},
})
export default class Home extends Vue {

}
